import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import EigenwijsOptionControls from "features/option-controls/eigenwijs-option-controls";
import { EigenwijsLayout } from "features/option-controls/layout-option-controls/eigenwijs-layout";
import Text from "shared/ui/typography/Text";

export const EigenwijsOptionSetup = () => {
  const {
    sortedLayoutList,
    eigenwijs_layout,
    updateLayout,
    updateEigenwijsLayout,
    staanderPosition,
    staanderOption,
    updateStaander,
    selfAssembleDoorData,
  } = useConfigurationOptionsContext();

  //Dekaap as default layout when switching back from eigenwijs
  const defaultLayout =
    sortedLayoutList.find((layout) => layout.code === "dekaap") ??
    sortedLayoutList[0];

  return (
    <div>
      {sortedLayoutList.length > 0 ? (
        <>
          <EigenwijsLayout
            defaultLayout={defaultLayout}
            updateLayout={updateLayout}
            updateEigenwijsLayout={updateEigenwijsLayout}
            eigenwijs_layout={eigenwijs_layout}
            staanderPosition={staanderPosition}
            isStaanderAvailable={!!staanderOption}
            onChangeStaander={updateStaander}
            description={
              selfAssembleDoorData.selfAssembly
                ? "Kies voor één van onze vooringestelde ontwerpen óf bepaal zelf hoe je de liggers wilt indelen."
                : "Kies een opzet welke je zou willen beginnen? Of maak hem helemaal vanaf de frame."
            }
            title="Maak jouw eigen Eigenwijs deur"
          />
          <EigenwijsOptionControls />
        </>
      ) : (
        <Text>Loading...</Text>
      )}
    </div>
  );
};
